export default __webpack_public_path__ + "static/media/cleanUp.4e1506e2.jpg";